const state= {
    garuda_token: localStorage.getItem('garuda_token') || '',
};
const getters = {
    garudaToken: (state) => state.garuda_token
};
const actions = {
    async getGarudaToken({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`/api/garuda/token`, { refresh_token: false })
                .then(response => {
                    localStorage.setItem("garuda_token", response.data.data );
                    commit('setToken', response.data.data);
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    // Facilities
    async getGarudaFacilities({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/garuda/facilities`, { params: params })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async createGarudaFacilities({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`/api/garuda/facilities`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async uploadImageForFacilities({commit}, params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('file', params.file);
            axios({
                method: 'POST',
                url: `https://api.mydronefleets.com/inspection-ops/facilities/profileimage${params.facility_id}`,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                data: formData
            })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    // Inspections
    async getGarudaInspections({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/garuda/inspections`, { params: params })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    // Doucments
    // async getDocuments({state, commit}, params){
    //     return new Promise (async ( resolve, reject ) => {
    //         try {
    //             const response = await fetch(`https://api.mydronefleets.com/inspection-ops/documents?inspection_id=${params.inspection_id}`, {
    //                 method: "GET",
    //                 headers: {
    //                     'Authorization': `Bearer ${state.garuda_token}`
    //                 }
    //             });
    //             if (!response.ok) {
    //                 const error = {
    //                     message: `Response status: ${response.status}`,
    //                     status: response.status,
    //                 };
    //                 throw error;
    //             }
            
    //             const json = await response.json();
    //             resolve( json.data );
    //         } catch (error) {
    //             reject( error )
    //         }
    //     });
    // },
    async getDocuments({state, commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/garuda/documents`, { params: params })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async downloadDocument({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/garuda/media`, {
                method: "GET",
                responseType: 'blob',
                headers: {
                    Accept: "application/json",
                },
                params: params
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error)
            });
        });
    },
    // Export
    async exportFacilities({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/garuda/facilities/export`, { params: params })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async exportInspections({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/garuda/inspections/export`, { params: params })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
}

const mutations = {
    setToken(state, data) {
        state.garuda_token = data
    }
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
